import React, {useEffect} from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { analytics } from "../firebaseConfig";
import { logEvent } from "firebase/analytics";

const posts = [
  {
    title: "How AI Is Transforming Contract Review for Small Teams",
    slug: "/blog/ai-contract-review",
    excerpt: "See how AI tools help small legal and ops teams extract contract terms in seconds — no paralegal required.",
  },
  {
    title: "Why Every Startup Needs a Contract Management Strategy",
    slug: "/blog/startup-contract-strategy",
    excerpt: "Don’t let contracts slip through the cracks. Discover why early-stage companies need a smart contract game plan.",
  },
];

const BlogIndex = () => {
  useEffect(()=>{
    logEvent(analytics, 'blog_page');
  },[])
  
  return(
  <div className="px-6 py-20 max-w-4xl mx-auto text-white">
    <Helmet>
      <title>Blog | AI Contract Manager</title>
      <meta
        name="description"
        content="Explore expert articles on AI contract review, legal automation, and contract management strategy."
      />
      <link rel="canonical" href="https://www.aicontractmanager.com/blog" />
    </Helmet>

    <h1 className="text-4xl font-extrabold text-blue-400 mb-4">The AI Contract Manager Blog</h1>
    <p className="text-lg text-gray-400 mb-12">
      Tips, insights, and strategies for teams automating their contract workflows with AI.
    </p>

    <div className="space-y-8">
      {posts.map((post, idx) => (
        <div
          key={idx}
          className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 hover:border-blue-500 transition"
        >
          <h2 className="text-2xl font-semibold text-white mb-2">
            <Link to={post.slug} className="hover:text-blue-400">
              {post.title}
            </Link>
          </h2>
          <p className="text-gray-400">{post.excerpt}</p>
        </div>
      ))}
    </div>
  </div>
)};

export default BlogIndex;
